import { Input } from '../Input';

import makeString from './makeString';
import makeValidNumber from './makeValidNumber';

type InputOnChange = NonNullable<Parameters<typeof Input>[0]['onChange']>;
export type NumberProps = Omit<Parameters<typeof Input>[0], 'type' | 'suffix' | 'onChange' | 'value'> & {
  value: number | null;
  numberType?: 'integer' | 'float';
  onChange: (val: number | null, event?: Parameters<InputOnChange>[1]) => ReturnType<InputOnChange>;
  suffix?: Parameters<typeof Input>[0]['suffix'];
  min?: number;
  max?: number;
};

const NumberInput: React.FC<NumberProps> = ({ numberType, onChange, value, min, max, ...props }) => {
  const handleChange: Parameters<typeof Input>[0]['onChange'] = (val, event) => {
    onChange(makeValidNumber(val, { max, min, numberType }), event);
  };
  return <Input {...props} value={makeString(value)} type='number' inputMode='numeric' onChange={handleChange} />;
};

export default NumberInput;
